import PropTypes from 'prop-types';

const modalPropTypes = {
  modalTitle: PropTypes.string.isRequired,
  modalBody: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  openByDefault: PropTypes.bool,
  returnFocus: PropTypes.bool,
  showPrimaryButton: PropTypes.bool.isRequired,
  textPrimaryButton: PropTypes.string,
  funcPrimaryButton: PropTypes.func,
  showSecondaryButton: PropTypes.bool,
  textSecondaryButton: PropTypes.string,
  funcSecondaryButton: PropTypes.func,
  resetAction: PropTypes.func
};

const modalDefaultProps = {
  openByDefault: false,
  textPrimaryButton: '',
  returnFocus: true,
  funcPrimaryButton: () => {},
  showSecondaryButton: false,
  textSecondaryButton: '',
  funcSecondaryButton: () => {},
  resetAction: () => {}
};

export { modalPropTypes, modalDefaultProps };
